module["exports"] = [
  "#{city_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/address/city.js
// module id = 199
// module chunks = 0